// extracted by mini-css-extract-plugin
export default {"Buttons":"confirm-action-module_Buttons_GMyMD"};